import { Component } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { IonicModule, Platform, ToastController } from '@ionic/angular';
import { BrukerService } from '../../../services/bruker/bruker.service';
import { LoadingController } from '@ionic/angular';
import { ModalController } from '@ionic/angular';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-endrepassordside',
  templateUrl: 'endrepassordside.page.html',
  styleUrls: ['./endrepassordside.page.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, ReactiveFormsModule, FormsModule]
})
export class EndrepassordsidePage {
  endrepassordGroup: FormGroup;

  showOldPassword: boolean;
  showPassword: boolean;
  showPasswordConfirmed: boolean;

  errorMessage: string;

  modalPage: any;

  constructor(
    private _toast: ToastController,
    private _brukerService: BrukerService,
    public loadingController: LoadingController,
    public platform: Platform,
    public modalCtrl: ModalController
  ) {}

  ngOnInit() {
    this.endrepassordGroup = new FormGroup(
      {
        oldpassword: new FormControl('', Validators.required),
        newpassword: new FormControl(
          '',
          Validators.compose([Validators.required, Validators.minLength(4)])
        ),
        newpasswordconfirmed: new FormControl(
          '',
          Validators.compose([Validators.required])
        )
      },
      {
        // Sjekk at nytt passord er likt i begge felter
        validators: [
          this.confirmPasswordValidator(
            'newpassword',
            'newpasswordconfirmed'
          ).bind(this)
        ]
      }
    );
  }

  async putPassword() {
    if (
      this.endrepassordGroup.get('newpassword').value !=
      this.endrepassordGroup.get('newpasswordconfirmed').value
    ) {
      await this.displayToast('Passordene matcher ikke');
    } else {
      if (this.endrepassordGroup.get('newpassword').value.length < 4) {
        await this.displayToast('Passord er for kort');
      } else {
        //La oss poste passordene til server og se...
        const nyPassordJson = JSON.stringify({
          oldPassword: this.endrepassordGroup.get('oldpassword').value,
          newPassword: this.endrepassordGroup.get('newpassword').value,
          newPasswordRepeat: this.endrepassordGroup.get('newpasswordconfirmed')
            .value
        });

        const loading = await this.loadingController.create({
          message: 'Vennligst vent...',
          mode: 'ios'
        });
        await loading.present();

        this._brukerService.sendNewPassword(nyPassordJson).subscribe({
          next: async (response) => {
            this._toast
              .create({
                message: 'Oppdatert!',
                duration: 4000,
                position: 'middle',
                color: 'success'
              })
              .then((toast) => {
                loading.dismiss();
                toast.present();
              });

            this.modalCtrl.dismiss();
          },
          error: (err) => {
            this._toast
              .create({
                message:
                  'Passord ble dessverre ikke oppdatert, prøv igjen litt senere. Dersom feil vedvarer, kontakt kundeservice.',
                duration: 4000,
                position: 'middle',
                color: 'danger'
              })
              .then((toast) => {
                loading.dismiss();
                toast.present();
              });
          }
        });
      }
    }
  }

  togglePasswordText(intMode: number) {
    if (intMode == 1) this.showOldPassword = !this.showOldPassword;
    else if (intMode == 2) this.showPassword = !this.showPassword;
    else if (intMode == 3)
      this.showPasswordConfirmed = !this.showPasswordConfirmed;
  }

  freezeUI(freeze: boolean) {
    // console.log(freeze);
  }

  async displayToast(message: string) {
    this._toast
      .create({
        message: message,
        duration: 3000,
        position: 'middle',
        color: 'danger'
      })
      .then((toast) => toast.present());
  }

  cancel() {
    this.modalCtrl.dismiss();
  }

  getFormErrorMessage() {
    const newPasswordLength =
      this.endrepassordGroup.get('newpassword').value.length;
    if (newPasswordLength < 4 && newPasswordLength > 0)
      return 'Nytt passord er for kort';
    if (
      this.endrepassordGroup.get('newpassword').value !==
      this.endrepassordGroup.get('newpasswordconfirmed').value
    )
      return 'Passordene er ikke like';
    return '';
  }

  getIsFormValid() {
    return this.endrepassordGroup.valid;
  }

  confirmPasswordValidator(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];
      if (
        matchingControl.errors &&
        !matchingControl.errors.confirmPasswordValidator
      ) {
        return;
      }
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ confirmPasswordValidator: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }
}
